module.exports = __webpack_public_path__ + "static/media/angryEmoji.a66c3e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/angryEmoji.png
// module id = 840
// module chunks = 0